<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="8"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <div class="label">{{$t('Operation_method')}}</div>
        <el-select
          :placeholder="$t('User.accType')"
          v-model="way"
          :style="prefixStyle"
          class="short-select"
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in wayList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
<!--        具体的出入金方式-->
        <el-select
          v-model="type"
          :placeholder="$t('Way')"
          :style="backHendStyle"
          class="long-select"
          @change="toQuery"
          clearable
        >
          <el-option
            v-for="(item,index) in filterTypeList"
            :key="index"
            :label="item.desc"
            :value="item.payType"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="8"
        :md="12"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <div class="label">{{$t('processing_time')}}</div>
        <el-date-picker
          v-if="!realMobile"
          style="width: 100%"
          v-model="date"
          @change="toQuery"
          type="daterange"
          value-format="yyyy-MM-dd HH-mm-ss"
          :range-separator="phFileter('root.dateTo')"
          :start-placeholder="phFileter('root.startDate')"
          :end-placeholder="phFileter('root.endDate')"
        >
        </el-date-picker>
        <select-date-duration
          class="header-sub-item"
          v-model="date"
        ></select-date-duration>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "queryHeader",
  props: {
    typeList: {
      type: Array,
      default(){
        return [];
      }
    },
  },
  data() {
    let _this = this;
    return {
      way: '',
      wayList: [
        {label: _this.$t('Trade.depo'),value: 1}, // 入金
        {label: _this.$t('User.out'),value: 2}, // 出金
      ],
      type: '',
      date: [], // 时间
      outOptions: [
        {
          desc: _this.$t('Self_held_account_transfer_and_withdrawal'),
          payType: 21,
        },
        {
          desc: _this.$t('Transfer_and_withdraw_funds_from_other_accounts'),
          payType: 22,
        },
        {
          desc: _this.$t('Bank_card_payment'),
          payType: 4,
        },
        {
          desc: 'USDT' + _this.$t('User.out'),
          payType: 5,
        },
        {
          desc: 'ChipPay' + _this.$t('User.out'),
          payType: 6,
        },
      ]
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
    filterTypeList() {
      if(!this.typeList.length){
        return []
      }else {
        let enterList = this.typeList.filter((item) => {
          return item.type == 1;
        });
        /*let outerList = this.typeList.filter((item) => {
          return item.type == 2;
        });*/
        if(this.way == 1){
          return enterList[0].payTypeList;
        }else if(this.way == 2){
          return this.outOptions;// 出金参照旧rs生产的
        }
      }
    },
    prefixStyle(){
      if(this.realMobile){
        return {
          width: '120px'
        }
      }else {
        return {
          width: '25%'
        }
      }
    },
    backHendStyle(){
      if(this.realMobile){
        return {
          width: 'calc(100% - 120px)'
        }
      }else {
        return {
          width: '75%'
        }
      }
    }
  },
  methods: {
    phFileter(data){
      return this.$t(data)
    },
    toQuery(){
      this.$emit('toQuery');
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {

}
</style>
